import ProductCategoryProvider from "@/modules/delivery/providers/ProductCategoryProvider";


export default {
    state: {
        categories: [],
    },
    getters: {
        categories(state) {
            return state.categories
        },
        getCategories(state) {
            return state.categories
        },
        getCategoryNameById(state){
            return (id) => {
                let category = state.categories.find(category => category.id === id)
                return category ? category.name : ''
            }
        }
    },
    actions:{
        async fetchCategories({commit}) {
            let r = await ProductCategoryProvider.fetchProductCategory()
            commit("categories", r.data.fetchProductCategory)
            return r.data.fetchProductCategory
        },
    },
    mutations: {
        categories(state, categories) {
            state.categories = categories
        }
    }
}
